/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Task_Reminders_Remove_ErrorInputs */

const en_task_reminders_remove_error = /** @type {(inputs: Task_Reminders_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to remove reminder: ${i?.message}`)
};

const pt_br2_task_reminders_remove_error = /** @type {(inputs: Task_Reminders_Remove_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao remover lembrete: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to remove reminder: {message}" |
*
* @param {Task_Reminders_Remove_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_remove_error = /** @type {((inputs: Task_Reminders_Remove_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_Remove_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_remove_error(inputs)
	return pt_br2_task_reminders_remove_error(inputs)
});